
    import {Options, Vue} from 'vue-property-decorator';

    import SkeletonLoader from '@malt/joy-entrypoint/src/vue/SkeletonLoader.vue';

    @Options({
        components: {SkeletonLoader},
    })
    export default class CategorizationDetailsSkeleton extends Vue {
        get skeletonBorderRadius(): string {
            return '8px';
        }
    }
